var elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('#'+elementsForm[i]).removeClass('error');
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }
    }
    return contLogin;
}

$('.btnFormContacto').click(function () {
    //$('#formContacto').submit();
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
            $('#formContacto').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formContacto').submit();
        });
    });
});

$('#formContacto').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "nameContact",
        "lastNameContact",
        "cellphoneContact",
        "emailContact",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: https + "contact",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContacto")[0].reset();
                swal.close();
                swal({
                    text: "Gracias por contactarnos",
                    icon: imageURL,
                    button: "OK!",
                });
            }else{
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});


$('.btnFormContactoFoot').click(function () {
    //$('#formContactoFooter').submit();
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
            $('#formContactoFooter').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formContactoFooter').submit();
        });
    });
});

$('#formContactoFooter').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "nameContactFoot",
        "lastNameContactFoot",
        "cellphoneContactFoot",
        "emailContactFoot",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: https + "contactFoot",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContactoFooter")[0].reset();
                swal.close();
                swal({
                    text: "Gracias por contactarnos",
                    icon: imageURL,
                    button: "OK!",
                });
            }else{
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});
